export default __webpack_public_path__ + "static/media/Group 8249.982502ab.jpg";